module.exports = (require("./helpers/browser/js-loader")(require('./helpers/bundle-manifest').resolve("kD1lR"))).then(() => module.bundle.root('6TueN'));